module.exports = __webpack_public_path__ + "static/media/LogoAffiancatoCity.e2942e7d.png";